import { render, staticRenderFns } from "./PhotoCarouselViewer.vue?vue&type=template&id=32c78e76&scoped=true&"
import script from "./PhotoCarouselViewer.vue?vue&type=script&lang=ts&"
export * from "./PhotoCarouselViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoCarouselViewer.vue?vue&type=style&index=0&id=32c78e76&prod&lang=scss&scoped=true&"
import style1 from "./PhotoCarouselViewer.vue?vue&type=style&index=1&id=32c78e76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c78e76",
  null
  
)

export default component.exports